export const errorStyles = {
	root: {
		width: '100%',
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'flex-start',
		gap: 2
	},
	searchIcon: {
		color: 'text.secondary',
		width: '145px',
		height: '145px'
	},
	backButton: {
		color: 'primary.main',
		fontSize: '0.875rem'
	}
};
